<template>
	<div>
		<div class="d-flex justify-space-between">
			<h2 class="mb-4">Change Password</h2>
		</div>

		<v-container>
			<v-form ref="form" v-model="valid" @submit.prevent="changePassword">
				<v-row class="d-flex justify-center align-center">
					<v-col cols="6">
						<v-alert v-model="alert.show" :type="alert.type" dismissible>{{alert.message}}</v-alert>
						<v-text-field
							v-model="password"
							:rules="[(v) => !!v || 'Please specify password']"
							:type="passwordFieldType"
							:append-icon="passwordFieldType === 'password' ? 'mdi-eye' : 'mdi-eye-off'"
							@click:append="switchVisibility1"
							label="Password"
							dense
							rounded
							filled
							required
						></v-text-field>
						<v-text-field
							v-model="confirmPassword"
							:rules="[v => (!!v || 'Please confirm your password'), v => ((v && v === password) || 'The password does not match')]"
							:type="confirmPasswordFieldType"
							:append-icon="confirmPasswordFieldType === 'password' ? 'mdi-eye' : 'mdi-eye-off'"
							@click:append="switchVisibility2"
							label="Confirm Password"
							dense
							rounded
							filled
							required
						></v-text-field>
					</v-col>
				</v-row>
				<v-row class="d-flex justify-center align-center">
					<v-btn :disabled="!valid" class="px-8" type="submit" color="primary" rounded>Save Changes</v-btn>
				</v-row>
			</v-form>
		</v-container>
	</div>
</template>

<script>
import axios from "axios";

export default {
	data() {
		return {
			valid: true,
			entity: {},
			password: null,
			confirmPassword: null,
			alert: { show: false, message: "" },
			baseLocation: axios.defaults.baseURL,
			passwordFieldType: "password",
			confirmPasswordFieldType: "password",
		};
	},
	computed: {
		fullName() {
			return this.entity.firstName + " " + this.entity.lastName;
		}
	},
	mounted() {
		this.getTenantStaff();
	},
	methods: {
		getTenantStaff() {
			axios.get("/system/staff?tenantId=" + this.$store.state.principal.tenantId + "&id=" + this.$store.state.principal.id).then(response => {
				this.entity = response.data;
			});
		},
		changePassword() {
			let formData = new FormData();
			if (this.password) {
				this.entity.password = this.password;
			}
			formData.append("entity", JSON.stringify(this.entity));

			axios
				.post("/system/staff/changepassword", formData, {
					headers: {
						"Content-Type": "multipart/form-data"
					}
				})
				.then(() => {
					this.alert.show = true;
					this.alert.type = "success";
					this.alert.message = "Your password has been changed";
					this.$refs.form.reset();
				});
		},
		switchVisibility1() {
			this.passwordFieldType = this.passwordFieldType === "password" ? "text" : "password";
		},
		switchVisibility2() {
			this.confirmPasswordFieldType = this.confirmPasswordFieldType === "password" ? "text" : "password";
		},
	}
};
</script>